import React from 'react';

interface Tab {
  key: string;
  label: string;
  icon?: React.ReactNode;
  count?: number;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (key: string) => void;
  className?: string;
}

export default function Tabs({ tabs, activeTab, onChange, className = '' }: TabsProps) {
  return (
    <div className={`inline-flex bg-surface-container-low rounded-card p-1 gap-1 ${className}`}>
      {tabs.map(tab => (
        <button
          key={tab.key}
          onClick={() => onChange(tab.key)}
          className={`inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-[0.5rem] transition-all ${
            activeTab === tab.key
              ? 'bg-surface-container-lowest text-on-surface shadow-ambient'
              : 'text-on-surface-variant hover:text-on-surface'
          }`}
        >
          {tab.icon && <span className="w-4 h-4">{tab.icon}</span>}
          {tab.label}
          {tab.count !== undefined && (
            <span className={`text-xs px-1.5 py-0.5 rounded-pill ${
              activeTab === tab.key ? 'bg-surface-container-low' : 'bg-surface-container-highest'
            }`}>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
